import { createElement, type CSSProperties } from "react";
import type * as React from "react";

/**
 * Renders a product name with the trailing Q in brand-primary (Steel blue).
 * Used in headings, nav, cards, labels - anywhere product names appear in designed contexts.
 * Set steelQ={false} for body text where Q should inherit surrounding color.
 */
export default function ProductName({
  name,
  className = "",
  as: Tag = "span",
  steelQ = true,
  style,
}: {
  name: string;
  className?: string;
  as?: keyof React.JSX.IntrinsicElements;
  steelQ?: boolean;
  style?: CSSProperties;
}) {
  if (!steelQ || !name.endsWith("Q")) {
    return createElement(Tag, { className, style }, name);
  }

  const base = name.slice(0, -1);
  return createElement(
    Tag,
    { className, style },
    base,
    createElement("span", { style: { color: "var(--color-brand-primary)" } }, "Q")
  );
}
